import styled from 'styled-components/macro';
import { space } from '../../../theme/tokens';
import * as Form from '../../common/elements/Form';
import { RoundProfileImage } from '../../common/elements/ProfileImage';
import * as StaffCommon from '../../common/elements/Staff';

export const UserInfoSection = styled.section`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${space[3]};
  min-width: 0;
`;

export const StaffUserHeader = styled(StaffCommon.StaffHeader)``;

export const StaffUserProfileImage = styled(RoundProfileImage)`
  flex-shrink: 0;
  /* avatar box size */
  height: 5.6rem;
  width: 5.6rem;
`;

export const StaffRowFill = styled(StaffCommon.StaffRow)`
  flex-grow: 1;
  justify-content: flex-end;
  margin: 0;
`;

export const ChatButton = styled(Form.CreateButton)``;

export * from '../../common/elements/Form.js';
export * from '../../common/elements/Notifications.js';
export * from '../../common/elements/Staff.js';
